import React from "react";
import getClassNameFactory from "../../../../utilities/classNames";
import Animation from "../../../../modules/Animation";
var ToggleContainer = /*#__PURE__*/React.forwardRef(function (_ref, ref) {
  var isInline = _ref.isInline,
      isExpanded = _ref.isExpanded,
      children = _ref.children;
  var getClassName = getClassNameFactory(ToggleContainer.displayName);
  var rootClassName = getClassName();

  if (isInline) {
    return /*#__PURE__*/React.createElement("div", {
      className: rootClassName
    }, children);
  }

  return /*#__PURE__*/React.createElement(Animation, {
    className: rootClassName,
    setPose: function setPose(startingPose, endingPose) {
      return isExpanded ? endingPose : startingPose;
    },
    type: "VISIBILITY"
  }, /*#__PURE__*/React.createElement("div", {
    className: getClassName({
      descendantName: "inner"
    }),
    ref: ref,
    tabIndex: -1
  }, children));
});
ToggleContainer.displayName = "ShowMore.ToggleContainer";
ToggleContainer.defaultProps = {
  isInline: false
};
export default ToggleContainer;